<script>
    import Card from "../components/card.svelte";
    // import ModalConfirm from "../components/modalconfirm.svelte";
    import Modal from "../components/modal.svelte";
    import wrappedFetch from "../../wrappedFetch.js";
    import DataTable from '../../components/data-table.svelte';
   // import { popupAction } from '../../components/popup-action.js';
    import Button from '../components/button.svelte';
    export let unmatchedUsers = [];
    export let role ="";
    export let onGetUnmatchedUsers;
    export let providerId = 0;
    let matchedUsers = [];
    let showResultModal = false;
    let showModal = false;
    let isPageLoading = false;
    // let showConfirmModal=false;
    // let confirmMessage="";
    // let confirmModalHeader="";
    let selectedUser;
    let isButtonLoading=false;
    let userToCreateOrMatch;
    let action;
    let resultMessage="";
    let order = [[1, "asc"]];

    const getPossibleMatches = async (user) => {
      
        //user.id=5;
        isPageLoading = true;
        let resp = await wrappedFetch(
            `/api/cloudConfig/GetPendingUsersMatches?pendingUserId=${user.id}`,
            {
                method: "post",
            }
        );
        // let resp = await wrappedFetch(`/api/reports/GetPossibleMatchedPupil`, {
        //     method: "post",
        //     body: JSON.stringify(user),
        //     headers: {
        //         "Content-Type": "application/json",
        //     },
        // });

        matchedUsers = await resp.json();
        isPageLoading = false;
    };

    const showMatchOptions = async (user) => {
        showResultModal = false;
        selectedUser = user;
        await getPossibleMatches(user);
        showModal = true;
    };

    // const confirm = (user,actionType) => {     
    //     userToCreateOrMatch = user;
    //     action = actionType; 
    //     confirmModalHeader = `Match ${role}`;
    //     confirmMessage = `Are you sure you would like to ${action} this user?`
    //     //showConfirmModal= true;
    // }

    const createUser=async(user)=>{
        let resp = await wrappedFetch(
            `/api/cloudConfig/MarkPendingAction?pendingUserId=${user.id}&actionId=1&providerId=${providerId}`,
            {
                method: "post",
            }
        );
        //  unmatchedUsers = await resp.json();  
        unmatchedUsers = await onGetUnmatchedUsers();
        let result = {message:`${role} created successfully`}
        return result;
    }
    
    const matchUser=async(user)=>{
        let resp = await wrappedFetch(
                    `/api/cloudConfig/MarkPendingAction?pendingUserId=${user.pendingUserId}&actionId=2&selectedMatchEmail=${user.primaryEmail}&providerId=${providerId}`,
                    {
                        method: "post",
                    }
                );
        // let resp={message:"Pupil matched successfully"}
        unmatchedUsers = await onGetUnmatchedUsers();
        let result = {message:`${role} matched successfully`}
        return result;
    }
    
    const onHandleConfirm =async(user, actionType)=>{
        userToCreateOrMatch = user;
        action = actionType; 
        let resp;
        isButtonLoading = true;
        
        if(action == "create")
             resp= await createUser(userToCreateOrMatch);
        else if (action == "match")
            resp= await matchUser(userToCreateOrMatch);

        resultMessage= resp.message;
        isButtonLoading = false;
        showModal =false; 
        showResultModal=true;  
    }

    
    document.addEventListener('click', function (event) {
        if (!event.target.matches('.ExportMatchUserbtn')) return;
        if (jQuery('div.dtr-bs-modal').length > 0){
            jQuery('.dtr-bs-modal').modal('hide');
        }
        u = matchedUsers.find(x => x.personId === (parseInt(event.target.getAttribute('data'))));
        
        onHandleConfirm(u, 'match');
    }, false);
    

    document.addEventListener('click', function (event) {
        if (!event.target.matches('.ExportPopMatchUserbtn')) return;
        if (jQuery('div.dtr-bs-modal').length > 0){
            jQuery('.dtr-bs-modal').modal('hide');
        }
        u = matchedUsers.find(x => x.personId === (parseInt(event.target.getAttribute('data'))));
        
        onHandleConfirm(u, 'create');
    }, false);
    

    document.addEventListener('click', function (event) {
        if (!event.target.matches('.ExportMatchOptionbtn')) return;
        if (jQuery('div.dtr-bs-modal').length > 0){
            jQuery('.dtr-bs-modal').modal('hide');
        }
        u = unmatchedUsers.find(x => x.personId === (parseInt(event.target.getAttribute('data'))));
        showMatchOptions(u)
    }, false);
</script>

<!-- pendingUsersList-->
<div class="row">
    <div class="col-12">   
        <DataTable message="There were no records waiting to be matched." DataLength={unmatchedUsers.length} {order}  ResponsiveHeader='0,1'>
            <thead>
                <tr>
                    <th width="20%">First Name</th>
                    <th width="20%">Last Name</th>
                    <th width="20%">Email</th>  
                    <th width="20%">Reason</th>                              
                    <th width="20%" />
                </tr>
            </thead>
            <tbody>
                {#each unmatchedUsers as user}
                    <tr>
                        <td>{user.firstName || ''}</td>
                        <td>{user.lastName || ''}</td>
                        <td>{user.primaryEmail || ''}</td>   
                        <td><span class="text-danger">{user.reason == 0?'Duplicate':user.reason ==1 ?'Name mismatch': ''}</span></td>                               
                        <td>
                            <a
                                class="btn btn-grey ExportMatchOptionbtn"
                                style="margin-top:-4px;"
                                href="#"
                                data={user.personId}
                                data-toggle="modal"
                                data-target=".match-options"
                                on:click={() => showMatchOptions(user)}>Match
                                Options</a>
                        </td>
                    </tr>
                {/each}
            </tbody>
        </DataTable>
       
    </div>
</div>


<!-- pendingUsersList-->

<!-- matchOptions-->
<Modal {showModal}
bind:isPageLoading ={isPageLoading}
    on:close={() => {
        resultMessage = ''; 
        showModal = false;
    }}
    targetClass="match-options">
    <div slot="header"> 
        <h4 class="title"> Create a new account or match an existing one </h4>
    </div>
    <div slot="content">
        <Card>
            <div slot="header">  
                <h5 style="margin-bottom: 0;">Selected {role} </h5>
            </div>
            <div slot="body">
                <div
                    class="row"
                    style="margin-bottom: 2px;">
                    <div class="col-lg-6">
                        <label for="firstName"><b>First Name:</b></label>&nbsp;<span>{selectedUser.firstName || ''}</span>
                    </div>
                    <div class="col-lg-6">
                        <label for="dob"><b>Email:</b></label>&nbsp;<span>{selectedUser.primaryEmail || ''}</span>
                    </div>
                    <div class="col-lg-6">
                        <label for="lastName"><b>Last Name:</b></label>&nbsp;<span>{selectedUser.lastName || ''}</span>
                    </div>
                    <div class="col-lg-6">
                        <label for="dob"><b>Reason:</b></label>&nbsp;<span class="text-danger">{selectedUser.message?selectedUser.message: ''}</span>
                    </div>
                    <div class="col-lg-6">
                        <label for="uso"><b>USO:</b></label>&nbsp;<span>{selectedUser.universalId || ''}</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-12 mt-3">
                    <Button buttonClass={"btn-primary ExportPopMatchUserbtn float-left"} buttonStyle={"width:147.5px;"} buttonText={"Create New"}
                     isConfirm={true} isLoading={isButtonLoading}
                     popupTitle='Are you sure you would like to create this user?'
                     dataid={selectedUser.personId}
                     on:confirmPopup={() => {
                         onHandleConfirm(selectedUser,'create');
                     }}   />
                        <!-- <button
                            id="ignore"
                            class="btn btn-primary float-left"
                            style="width:147.5px;"
                            disabled={isButtonLoading}
                            use:popupAction={{
                                rootSelector: '[data-toggle=confirmation]', 
                                singleton: true,
                                popout: true,
                                placement: 'right', 
                                title: `Are you sure you would like to create this user?`,
                                onConfirm : () => { onHandleConfirm(selectedUser, 'create') } }} >
                            {#if isButtonLoading}
                                <span class="spinner-grow spinner-grow-sm" />
                            {:else}Create New {/if}
                        </button> -->
                        {#if matchedUsers.length > 0}<span style="display:inline-block;padding:0.5rem;"> OR MATCH BELOW</span>{/if}
                    </div>
                </div>
            </div>
        </Card>       

        <br />
        {#if resultMessage != ''}
            <div class="row">
                <div class="col-lg-12">
                    <span class="text-danger">{resultMessage}</span>
                </div>
            </div>
            <br />
        {/if}
        {#if matchedUsers.length > 0}
            <!-- <p><b>Or Possible Matches</b></p> -->     
                <Card>
                    <div slot="header">  
                        <h5 style="margin-bottom: 0;">Matches in {#if providerId == 1}Google{:else}Microsoft{/if}</h5>
                    </div>
                    <div slot="body">
                        <DataTable DataLength={matchedUsers.length} message="There is currently no possible matches" {order} ResponsiveHeader='0,1' tableCSS='table-responsive'>
                            <thead>
                                <tr style="background-color:rgba(0, 0, 0, 0.03)">
                                    <th><b>First Name</b></th>
                                    <th><b>Last Name</b></th>
                                    <th><b>Email</b></th>
                                    <th><b>Action</b></th>
                                </tr>
                            </thead>
                            <tbody>
                                {#each matchedUsers as u}
                                    <tr>
                                        <td>{u.firstName || ''}</td>
                                        <td>{u.lastName || ''}</td>
                                        <td>{u.primaryEmail || ''}</td>  
                                        <td>
                                            <Button buttonClass={"btn-grey btn-sm ExportMatchUserbtn"} buttonStyle={"height:35px;"} buttonText={"Match"}
                                            isConfirm={true} isLoading={isButtonLoading}
                                            popupTitle='Are you sure you would like to match this user?'
                                            placement='bottom'
                                            dataid={u.personId}
                                            on:confirmPopup={() => {
                                                onHandleConfirm(u, 'match') 
                                            }}   />
                                            <!-- <button
                                                class="btn btn-grey btn-sm"
                                                style="height:35px;"
                                                disabled={isButtonLoading}
                                                use:popupAction={{
                                                    rootSelector: '[data-toggle=confirmation]', 
                                                    singleton: true,
                                                    placement: 'bottom', 
                                                    title: `Are you sure you would like to match this user?`,
                                                    onConfirm : () => { onHandleConfirm(u, 'match') } }} >
                                                {#if isButtonLoading}
                                                    <span class="spinner-grow spinner-grow-sm" />
                                                {:else}Match{/if}
                                            </button> -->
                                        </td>
                                    </tr>
                                {/each}
                            </tbody>
                        </DataTable>
                    </div>
                </Card>   
        {/if}
    </div>
   
</Modal>

<!-- matchOptions-->

<!-- <ModalConfirm
    bind:showModal={showConfirmModal}
    zindex="1052"
    sizeClass="modal-lg"  
    targetClass="confirm-options"
    on:confirm={onHandleConfirm}>
    <div slot="header">  <h4 class="title">{confirmModalHeader}</h4></div>
    <div slot="content">
        {@html confirmMessage}
    </div>
</ModalConfirm> -->

<!-- result after action-->
<Modal
    showModal={showResultModal}
    on:close={() => (resultMessage = '')}
    sizeClass="modal-lg">
    <div slot="header">
        <h4 class="title"><span class='info fas fa-info-circle'/> Info</h4>
    </div>
    <div slot="content">
        {@html resultMessage}
    </div>
</Modal>
<!-- result after action-->
